"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_redux_1 = require("react-redux");
/**
 * Helper function to extract a single network status from the state. If no status is
 * found, return 'initial' as a fallback.
 */
function extractStatus(state, id) {
    if (id in state.requests) {
        return state.requests[id];
    }
    return 'initial';
}
/**
 * Return the request status for the provided id. If nothing is found, returns
 * 'initial' as a fallback. The value assigned will keep track of the request's status,
 * so you can rely on it for conditional renders or useEffect dependency triggers.
 *
 * Use this hook instead of directly querying for the request status in the state, since it
 * skips the automatic reset to 'initial' triggered by networkStatusResetEpic.ts
 * (implemented via redux-observable).
 *
 * While it is necessary for the store's values to auto-reset on either success or failure
 * (otherwise some pages that redirect on those status codes would be unreachable once the
 * first request finishes), there are places where this request state needs to be kept on the
 * last "resolved" status, hence why it is kept inside a `useState` declaration.
 *
 * @param id - The request's unique id
 */
function useNetworkObserver(id) {
    var networkStatusState = react_redux_1.useSelector(function (state) { return state.networkStatus; });
    var fetchedStatus = extractStatus(networkStatusState, id);
    var _a = react_1.useState(fetchedStatus), savedStatus = _a[0], updateSavedStatus = _a[1];
    /**
     * Only update if the new status is not 'initial'.
     */
    react_1.useEffect(function () {
        if (fetchedStatus !== 'initial') {
            updateSavedStatus(fetchedStatus);
        }
    }, [fetchedStatus, updateSavedStatus]);
    return savedStatus;
}
exports.default = useNetworkObserver;
//# sourceMappingURL=useNetworkObserver.js.map